module.exports = __webpack_public_path__ + "static/media/icon-menu.33bf0e4c.svg";